import { render, staticRenderFns } from "./UpdateMember.vue?vue&type=template&id=ea06a97c"
import script from "./UpdateMember.vue?vue&type=script&lang=ts"
export * from "./UpdateMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports